import {
    CMM_CONVERSATION_STEPS,
    CMMBranch,
    type CMMConversationStep,
    type SproutHandoffTarget,
} from '@fruitful/types';

export const isRecord = (value: unknown): value is Record<string, unknown> => {
    return typeof value === 'object' && value != null && !Array.isArray(value);
};

export const parseNonEmptyString = (value: unknown): string | undefined => {
    if (typeof value !== 'string') {
        return undefined;
    }

    const trimmed = value.trim();
    return trimmed === '' ? undefined : trimmed;
};

export const isCMMBranch = (value: unknown): value is CMMBranch => {
    return (
        typeof value === 'string' &&
        (Object.values(CMMBranch) as string[]).includes(value)
    );
};

export const isCMMStep = (value: unknown): value is CMMConversationStep =>
    typeof value === 'string' &&
    (CMM_CONVERSATION_STEPS as readonly string[]).includes(value);

export const toHandoff = (value: unknown): SproutHandoffTarget | null => {
    return value === 'guide' || value === 'support' ? value : null;
};

export const toNullableNumber = (value: unknown): number | null => {
    return typeof value === 'number' ? value : null;
};

export const toNullableIsoString = (value: unknown): string | null => {
    return typeof value === 'string' && value !== '' ? value : null;
};
